import orderRegistrations from '../slices/orderRegistrations';
import type { RootStateType, ThunkDispatchType } from '../index';
import {
    getOrderRegistration,
    getOrderRegistrations
} from '../../api-admin/order-registrations';

export function fetchAllOrderRegistrations() {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(orderRegistrations.actions.fetchAll());
            const data = await getOrderRegistrations();
            dispatch(orderRegistrations.actions.allFetched({ data }));
        } catch (e) {
            console.log('ERROR fetching order registrations', e);
            dispatch(orderRegistrations.actions.allFetched({ data: [] }));
        }
    };
}

export function fetchOrderRegistrationById(id: number) {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(orderRegistrations.actions.fetchById({ id }));
            const data = await getOrderRegistration(id);
            dispatch(orderRegistrations.actions.byIdFetched({ id, data }));
        } catch (e) {
            console.log('ERROR fetching order registration', e);
            dispatch(orderRegistrations.actions.byIdFetched({ id }));
        }
    };
}

export const selectAllOrderRegistrations = () => (
    state: RootStateType
) => state.orderRegistrations.all;

export const selectFetchingAllOrderRegistrations = () => (
    state: RootStateType
) => state.orderRegistrations.fetchingAll;

export const selectOrderRegistrationById = (id: number) => (
    state: RootStateType
) => state.orderRegistrations.byId[id];

export const selectFetchingOrderRegistrationById = (id: number) => (
    state: RootStateType
) => !!state.orderRegistrations.fetchingById[id];
